import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import {
    Grid,
    Paper,
    Box
} from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableFooter from "@material-ui/core/TableFooter";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";

import TableHead from "@material-ui/core/TableHead";

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.common.white,
        color: theme.palette.primary.main,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

function TableSftoAndGpwisSkeleton() {
    return (
        <div>
            <TableHead>
                <TableRow>
                    <StyledTableCell align="center">
                        <b>Job Created Date</b>
                    </StyledTableCell>
                    <StyledTableCell align="center">
                        <b>Job ID</b>
                    </StyledTableCell>
                    <StyledTableCell align="center">
                        <b>Rake Name</b>
                    </StyledTableCell>
                    <StyledTableCell align="center">
                        <b>Rake Type</b>
                    </StyledTableCell><StyledTableCell align="center">
                        <b>Origin</b>
                    </StyledTableCell><StyledTableCell align="center">
                        <b>Origin Code</b>
                    </StyledTableCell><StyledTableCell align="center">
                        <b>Destination</b>
                    </StyledTableCell><StyledTableCell align="center">
                        <b>Destination Code</b>
                    </StyledTableCell><StyledTableCell align="center">
                        <b>Advance Paid Date</b>
                    </StyledTableCell><StyledTableCell align="center">
                        <b>Rake Arrival at Yard Date/Time</b>
                    </StyledTableCell><StyledTableCell align="center">
                        <b>Railways Inspection Start Date/Time</b>
                    </StyledTableCell><StyledTableCell align="center">
                        <b>Railways Inspection End Date/Time</b>
                    </StyledTableCell><StyledTableCell align="center">
                        <b>Offered to Customer</b>
                    </StyledTableCell><StyledTableCell align="center">
                        <b>Made Over Date Time</b>
                    </StyledTableCell><StyledTableCell align="center">
                        <b>Arrival at Plant Date Time</b>
                    </StyledTableCell><StyledTableCell align="center">
                        <b>Rake Placement Date Time</b>
                    </StyledTableCell><StyledTableCell align="center">
                        <b>Loading Start Date Time</b>
                    </StyledTableCell><StyledTableCell align="center">
                        <b>Loading End Date Time</b>
                    </StyledTableCell><StyledTableCell align="center">
                        <b>Offered to Railways</b>
                    </StyledTableCell><StyledTableCell align="center">
                        <b>Drawout Date Time</b>
                    </StyledTableCell><StyledTableCell align="center">
                        <b>RR No.</b>
                    </StyledTableCell><StyledTableCell align="center">
                        <b>RR Date</b>
                    </StyledTableCell><StyledTableCell align="center">
                        <b>RR Chargeable Weight</b>
                    </StyledTableCell><StyledTableCell align="center">
                        <b>RR Amount</b>
                    </StyledTableCell><StyledTableCell align="center">
                        <b>Rebate Amount</b>
                    </StyledTableCell><StyledTableCell align="center">
                        <b>Loco Allotment Date Time</b>
                    </StyledTableCell><StyledTableCell align="center">
                        <b>Engine on Train Date Time</b>
                    </StyledTableCell><StyledTableCell align="center">
                        <b>Rake Departure Date Time</b>
                    </StyledTableCell><StyledTableCell align="center">
                        <b>Actual Arrival at Destination Date Time</b>
                    </StyledTableCell><StyledTableCell align="center">
                        <b>Rake Placement Date Time</b>
                    </StyledTableCell><StyledTableCell align="center">
                        <b>Unloading Start Date Time</b>
                    </StyledTableCell><StyledTableCell align="center">
                        <b>Unloading End Date Time</b>
                    </StyledTableCell><StyledTableCell align="center">
                        <b>Return Departure Date Time</b>
                    </StyledTableCell><StyledTableCell align="center">
                        <b>Rake Arrival Date Time</b>
                    </StyledTableCell>
                    <StyledTableCell align="center">
                        <b>Commodity</b>
                    </StyledTableCell>
                    <StyledTableCell align="center">
                        <b>Special Instructions</b>
                    </StyledTableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                <TableRow>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>

                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>

                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>

                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>

                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                    <TableCell align="center">
                        <Skeleton height={25} width={120} variant="rect" />
                    </TableCell>
                </TableRow>

            </TableBody>
        </div>
    )
}

export default TableSftoAndGpwisSkeleton;
